// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__34v1y","label":"Section_label__1RdHw","contentWrap":"Section_contentWrap__3OsQf","footer":"Section_footer__2lT7j","footerInner":"Section_footerInner__UZkxR"};